import { themeStyle } from '@src/theming';

import { DefaultConfiguration, ToastTypes } from './store/types';

/** Duration of the the enter and leave transitions, in ms */
export const STATE_TRANSITION_DURATION = 150;

/** The maximum amount of toasts visible at any time */
export const SHOW_TOAST_AMOUNT = 5;

export const DEFAULT_TOAST_CONFIG: DefaultConfiguration = {
  type: ToastTypes.DEFAULT,
  label: '',
  duration: 1500,
  delay: 0,
  error: false,
  small: false,
  theme: {
    fontSize: themeStyle.fontSize16,
    fontWeight: themeStyle.fontSemiBold,
    color: themeStyle.varBackgroundAlt,
    background: themeStyle.varInkMain,
    iconColor: themeStyle.varBrandMain,
    errorIconColor: themeStyle.varAlertRed,
    secondaryIconColor: themeStyle.inkBase,
    shadow: themeStyle.varShadowHeavy,
  },
};
